// src/components/pricing/UpgradeButton.tsx

"use client";

import { Button } from "@/components/ui/Button";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { createCheckoutSession } from "./action";
import { PricingPlan } from "@/types/types";


interface UpgradeButtonProps{
  planDetails: PricingPlan
}
const UpgradeButton = ({ planDetails }: UpgradeButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  
  async function handleCheckoutSessionClick() {
    setIsLoading(true);
    try {
      const priceId = planDetails.price.priceIds.production;
      console.log(`\t🚀🚀🚀 priceId: ${priceId}`);
      const redirectUrl = await createCheckoutSession( priceId);
      console.log(`🚀 redirectUrl: ${redirectUrl}`);

      // window.location.href = redirectUrl;
      // Use window.location.assign for cleaner redirect handling
      window.location.assign(redirectUrl);
    } catch (error) {
      console.error("Error creating Stripe session:", error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Button
      onClick={() => handleCheckoutSessionClick()}
      className="w-full"
      disabled={isLoading}
    >
      Upgrade now <ArrowRight className="h-5 w-5 ml-1.5" />
    </Button>
  );
};

export default UpgradeButton;
